import React from 'react'
import Animal from './Animal'
import config from './config'

class LoadAnimal extends React.Component {
	constructor(props) {
		super(props)
		this.state = { data: [] }
	}

	async componentDidMount() {
		const uri = config.API + 'product'
		const res = await fetch(uri)

		if (!res.ok) {
			console.log('Error / load data : ', res)
			return
		}

		const data = await res.json()
		this.setState({ data: data })
	}

	render() {
		return (
			<Animal name="URB/ZOO:動物" data={this.state.data} />
		)
	}
}

export default LoadAnimal